export const sectionDividerSx = { mt: 1, mb: 2 };
export const fieldBottomGapSx = { mb: 1.25 };
